import React, { useEffect, useState } from "react";
import "./NewPortfolio.css";
import AOS from "aos";
import "aos/dist/aos.css";
import kidson from "../Images/kidson.png";
import knowella from "../Images/knowella.png";
import outcaster from "../Images/outcaster.jpeg";
import tatto from "../../components/assets/images/tatto.png"
import luke from "../../components/assets/images/luke.png"
import HeaderPort from "./HeaderPort";
import HomePort from "./HomePort";
import SkillsPort from "./SkillsPort";
import ProjectPort from "./ProjectPort";
import ContactMe from "./ContactMe";
import FooterPort from "./FooterPort";
import AboutMe from "./AboutMe";
const NewPortfolio = () => {
  const [hide, setHide] = useState(window.innerWidth);

  useEffect(() => {
    AOS.init();
    const handleWidth = () => {
      if (window.innerWidth < 786) {
        setHide(false);
      } else {
        setHide(true);
      }

      console.log("here is the hide : ", hide);
    };
    window.addEventListener("resize", handleWidth);

    return () => {
      window.removeEventListener("resize", handleWidth);
    };
  }, [hide, setHide]);
  const dataProject = [
    {
      Image: outcaster,
      title: "The Outcaster",
      paragrapgh:
        "  This is the React web Application I make it only for Web  ",
      Link: "Visit Website",
      hreflink: "https://outcaster.onrender.com/",
    },
    {
      Image: knowella,
      title: "Knowella",
      paragrapgh:
        "   This is the knowella Web Application this is done the angular js I Make it fully responsive.",
      Link: "Visit Website",
      hreflink: "https://app.knowella.com",
    },
    {
      Image: kidson,
      title: "KidsonTheYard",
      paragrapgh:
        "   This the kidson on the yard Web App through which People Can insert Data they can find many Tutor for Childs.",
      Link: "Visit Website",
      hreflink: "https://v1.kidsontheyard.dev/",
    },
    {
      Image: tatto,
      title: "Tatto Night",
      paragrapgh:
      " I created a website for a tattoo shop where you can book appointments with available artists. To use it, you need to register first, and once approved by the admin, you can search and access all artist records",
      Link: "Visit Website",
      hreflink: "https://tattonight.com/",
    },
    {
      Image: kidson,
      title: "KidsonTheYard",
      paragrapgh:
        "   This the kidson on the yard Web App through which People Can insert Data they can find many Tutor for Childs.",
      Link: "Visit Website",
      hreflink: "https://v1.kidsontheyard.dev/",
    },
    {
    Image: luke,
    title: "Luke Temple",
    paragrapgh:
      "   Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates consequuntur eum recusandae ducimus molestias",
    Link: "Visit Website",
    hreflink:
      "https://65a127dcbec86dbcc7b528c3--singular-scone-f8c454.netlify.app/",
  },
  ];

  const skillsData = [
    { id: 1, name: "JavaScript", level: "Intermediate" },
    { id: 2, name: "React", level: "Intermediate" },
    { id: 3, name: "HTML", level: "Intermediate" },
    { id: 4, name: "CSS", level: "Intermediate" },
    { id: 5, name: "Next Js", level: "Intermediate" },
    { id: 6, name: "GitLab", level: "Intermediate" },
    { id: 7, name: "GitHub", level: "Intermediate" },
    { id: 8, name: "Bootstrap", level: "Intermediate" },
    { id: 9, name: "Tailwind Css", level: "Intermediate" },
    { id: 10, name: "Ant Design", level: "Intermediate" },
    { id: 11, name: "Angular js", level: "Intermediate" },
  ];
  const [show, setShow] = useState(true);
  return (
    <div>
      <div className="container-fluid  mainDropFilter ">
        <HeaderPort hide={hide} setHide={setHide} />
        <HomePort show={show} setShow={setShow} />
        <SkillsPort skillsData={skillsData} />
        <ProjectPort dataProject={dataProject} />
        <AboutMe />
        <ContactMe />
        <FooterPort />
      </div>
    </div>
  );
};

export default NewPortfolio;
